import {Pipe, PipeTransform} from '@angular/core';
import {filterByField} from "@utility";

@Pipe({
    name: 'getByField',
    standalone: false
})
export class GetByFieldPipe implements PipeTransform {

    transform(items: any[] | undefined, field: string, value: any, returnField?: string | undefined, differentThanValue?: boolean | undefined): any {
        const filteredItems = filterByField(items, field, value, differentThanValue);
        return filteredItems.length > 0 ? !returnField ? filteredItems.at(0) : filteredItems.at(0)[returnField]: undefined;
    }
}
